import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Box,
  Button,
  TextField,
  Paper,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { BrandAdd } from "./BrandAddModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteBrandAction,
  getbrands,
} from "../../../../redux/actions/BrandAction";
import useAlert from "../../../../hooks/useAlert";
import { BrandUpdate } from "./BrandUpdate";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";
import DeleteIcon from "@mui/icons-material/Delete";
import BrandMatching from "./BrandMatchingModal";
import { CircleRounded } from "@mui/icons-material";

export const BrandGrid = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [openDialogAdd, setOpenDialogAdd] = useState(false);
  const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleAddModal = () => {
    setOpenDialogAdd(true);
  };

  const [selectedBrandForEdit, setSelectedBrandForEdit] = useState(null);

  const handleEditBrand = (brand) => {
    setSelectedBrandForEdit(brand);
    setOpenDialogUpdate(true);
  };
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const handleSearchChange = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
  };
  const handleSearch = () => {
    setPage(1);
    dispatch(getbrands(authUserId, token, page, searchTerm));
  };

  const { showSuccessBrandDelete, showErrorAlertBrandDelete } = useAlert();
  const deleteBrand = async (id) => {
    const confirmDelete = window.confirm(
      "Bu markayı silmek istediğinizden emin misiniz?"
    );

    if (confirmDelete) {
      try {
        const response = await dispatch(deleteBrandAction(id, token));

        if (response.status) {
          showSuccessBrandDelete();
          dispatch(getbrands(authUserId, token));
        }
        return response;
      } catch (error) {
        showErrorAlertBrandDelete();
        console.error("Error deleting address:", error);
      }
    }
  };

  useEffect(() => {
    if (authUserId) {
      dispatch(getbrands(authUserId, token, page, searchTerm));
    }
  }, [page]);

  const brands = useSelector((state) => state?.brands);
  useEffect(() => {
    setData(brands?.brands?.data);
    setTotalCount(brands?.brands?.recordsTotal);
    setLoading(brands?.loading);
  }, [brands]);
  useEffect(() => {
    const pageSize = 10;
    setTotalPages(Math.ceil(totalCount / pageSize));
  }, [totalCount]);

  const [openModal, setOpenModal] = useState(false);
  const [modalBrand, setModalBrand] = useState(null);
  const handleOpenModal = (brand) => {
    setModalBrand(brand);
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setModalBrand(null);
    setOpenModal(false);
  };
  return (
    <Box
      sx={{
        width: "100%",
        mt: 5,
      }}
    >
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Box
          sx={{
            padding: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 4,
            mb: 3,
            ml: 1,
            backgroundColor: "#F7F9FC",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Başlık */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{ width: 4, height: 24, backgroundColor: "#1F1B45", mr: 1 }}
            />
            <Typography
              variant="h6"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              Markalar
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" },
            mb: 3,
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box sx={{ mt: { xs: 2, sm: 5 }, display: "flex", gap: 1 }}>
            <Button
              sx={{
                borderRadius: 2,
                backgroundColor: "#1F1B45",
                color: "#fff",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.875rem",
                padding: "6px 12px",
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
                "&:hover": {
                  backgroundColor: "#2C285A",
                },
              }}
              size="small"
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleAddModal}
            >
              Ekle
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            mb: 3,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: { xs: 2, sm: 0 },
          }}
        >
          <TextField
            fullWidth
            label="Marka Ara"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{
              mr: { xs: 0, sm: 2 },
            }}
          />
          <Button
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#fff",
              textTransform: "none",
              fontWeight: 500,
              fontSize: "0.875rem",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
            size="small"
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleSearch}
          >
            Filtrele
          </Button>
        </Box>

        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              overflowX: "auto",
              "& .MuiTableContainer-root": {
                minWidth: { xs: "100%", sm: 650 },
              },
            }}
          >
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: { xs: 120, sm: 200 } }}>
                      Marka Adı
                    </TableCell>
                    <TableCell sx={{ minWidth: { xs: 150, sm: 200 } }}>
                      Eşitleme Durumu
                    </TableCell>
                    <TableCell
                      sx={{
                        minWidth: { xs: 280, sm: 350 },
                        width: { xs: "100%", sm: 350 },
                      }}
                    >
                      İşlemler
                    </TableCell>
                  </TableRow>
                </TableHead>
                {filteredData?.length > 0 ? (
                  <TableBody>
                    {filteredData.map((item, index) => (
                      <TableRow key={index} sx={{ background: "white" }}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>
                          {item.marketPlaceBrands.length > 0
                            ? item.marketPlaceBrands.map((brand, index) => (
                                <div key={index}>
                                  {brand.marketPlace?.name ||
                                    brand.ecommercePlace?.name}{" "}
                                  Eşitlendi
                                </div>
                              ))
                            : "Eşitlenmedi"}
                        </TableCell>
                        <TableCell>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: { xs: "column", sm: "row" },
                              gap: 1,
                              justifyContent: "flex-start",
                            }}
                          >
                            <Button
                              sx={{
                                borderRadius: 2,
                                border: "1px solid #1F1B45",
                                color: "#1F1B45",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "0.875rem",
                                padding: "6px 12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                width: { xs: "100%", sm: "auto" },
                                "&:hover": {
                                  backgroundColor: "#F3F3F3",
                                  border: "1px solid #2C285A",
                                  color: "#2C285A",
                                },
                              }}
                              size="small"
                              variant="outlined"
                              startIcon={<EditIcon />}
                              onClick={() => handleEditBrand(item)}
                            >
                              Düzenle
                            </Button>
                            <Button
                              onClick={() => handleOpenModal(item)}
                              sx={{
                                borderRadius: 2,
                                border: "1px solid #1F1B45",
                                color: "#1F1B45",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "0.875rem",
                                padding: "6px 12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                width: { xs: "100%", sm: "auto" },
                                "&:hover": {
                                  backgroundColor: "#F3F3F3",
                                  border: "1px solid #2C285A",
                                  color: "#2C285A",
                                },
                              }}
                              size="small"
                              variant="outlined"
                              startIcon={<SyncIcon />}
                            >
                              Eşitle
                            </Button>
                            <Button
                              sx={{
                                borderRadius: 2,
                                border: "1px solid #1F1B45",
                                color: "#1F1B45",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "0.875rem",
                                padding: "6px 12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                width: { xs: "100%", sm: "auto" },
                                "&:hover": {
                                  backgroundColor: "#F3F3F3",
                                  border: "1px solid #2C285A",
                                  color: "#2C285A",
                                },
                              }}
                              size="small"
                              variant="outlined"
                              startIcon={<DeleteIcon />}
                              onClick={() => deleteBrand(item.id)}
                            >
                              Sil
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={3} align="center">
                        Henüz marka tanımlanmadı
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Box>
        )}

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
            marginTop: 2,
            marginBottom: 2,
          }}
        >
          <Button
            variant="outlined"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
            fullWidth
            sx={{ maxWidth: { sm: "auto" } }}
          >
            Geri
          </Button>

          <Typography variant="body1" component="span">
            Sayfa {page} / {totalPages}
          </Typography>

          <Button
            variant="contained"
            disabled={page >= totalPages}
            onClick={() => setPage((prev) => prev + 1)}
            fullWidth
            sx={{ maxWidth: { sm: "auto" } }}
          >
            İleri
          </Button>
        </Box>
        <BrandAdd
          openDialog={openDialogAdd}
          handleCloseDialog={() => setOpenDialogAdd(false)}
        />

        <BrandUpdate
          openDialog={openDialogUpdate}
          handleCloseDialog={() => setOpenDialogUpdate(false)}
          data={selectedBrandForEdit}
        />

        <BrandMatching
          open={openModal}
          handleClose={handleCloseModal}
          brandData={modalBrand}
        />
      </Paper>
    </Box>
  );
};
